import Brick from './BrickCore';
import ApplicationCreateBrick from './ApplicationCreateBrick';
import AuthKronosLoginBrick from './AuthKronosLoginBrick';
import BookOnTicketBrick from './BookOnTicketBrick';
import CartAddArticleBrick from './CartAddArticleBrick';
import CartSetUserData from './CartSetUserData';
import ContextSetData from './ContextSetData';
import EmailSendBrick from './EmailSendBrick';
import ForeachBrick from './ForeachBrick';
import FormHandleBrick from './FormHandleBrick';
import FormShowBrick from './FormShowBrick';
import MessageShowBrick from './MessageShowBrick';
import RedirectBrick from './RedirectBrick';
import TicketCreateBrick from './TicketCreateBrick';
import WaitApprovalBrick from './WaitApprovalBrick';
import WaitPaymentBrick from './WaitPaymentBrick';
import UserUpdateBrick from './UserUpdateBrick';
import UserApplyAbilitiesBrick from './UserApplyAbilitiesBrick';

const BRICK_CLASS_BY_TYPE = {
    'application.create': ApplicationCreateBrick,
    'auth.kronos.login': AuthKronosLoginBrick,
    'book.on.ticket': BookOnTicketBrick,
    'cart.add.article': CartAddArticleBrick,
    'cart.set.user.data': CartSetUserData,
    'context.set.data': ContextSetData,
    'email.send': EmailSendBrick,
    foreach: ForeachBrick,
    'form.handle': FormHandleBrick,
    'form.show': FormShowBrick,
    'message.show': MessageShowBrick,
    redirect: RedirectBrick,
    'ticket.create': TicketCreateBrick,
    'wait.approval': WaitApprovalBrick,
    'wait.payment': WaitPaymentBrick,
    'user.update': UserUpdateBrick,
    'user.apply.abilities': UserApplyAbilitiesBrick,
};

Brick.make = function make(props) {
    const { type } = props;
    const Ctor = type ? BRICK_CLASS_BY_TYPE[type] : null;
    if (!Ctor) {
        throw new Error(`Brick type ${type} not found!`);
    }
    return new Ctor(props);
};

Brick.getBrickTypes = function getBrickTypes() {
    return [
        'application.create',
        'auth.kronos.login',
        'book.on.ticket',
        'cart.add.article',
        'cart.set.user.data',
        'context.set.data',
        'email.send',
        'foreach',
        'form.handle',
        'form.show',
        'message.show',
        'redirect',
        'ticket.create',
        'wait.approval',
        'wait.payment',
        'user.update',
        'user.apply.abilities',
    ];
};

/** Class representing a workflow brick (includes {@link Brick.make}). */
export default Brick;
